import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NavBar = () => {
  const { logout } = useAuth();
  return (
    <div style={{
      background: '#fff',
      borderBottom: '3px solid #F96302',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 24px',
      height: 56,
      flexShrink: 0,
    }}>
      <Link to="/" style={{ lineHeight: 0, display: 'flex', alignItems: 'center' }}>
        <img
          src="./images/autozone-logo.png"
          alt="AutoZone"
          style={{ height: 38, objectFit: 'contain', display: 'block' }}
        />
      </Link>

      <button
        onClick={logout}
        style={{
          background: '#F96302',
          color: '#fff',
          border: 'none',
          borderRadius: 4,
          height: 36,
          width: 120,
          fontSize: 15,
          fontWeight: 600,
          cursor: 'pointer',
          letterSpacing: '0.5px',
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default NavBar;
